import { createFileRoute } from '@tanstack/react-router';

import { ClientLibraryScreen } from '@/features/engagement/components/ClientLibraryScreen';

export const Route = createFileRoute('/client/library/')({
  component: ClientLibraryRoute,
});

function ClientLibraryRoute() {
  return <ClientLibraryScreen />;
}
